module.exports = __webpack_public_path__ + "static/media/insurance-02.06718303.jpg";